// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","grey":"#707070","medium-grey":"#9f9f9f","light-grey":"#d4d4d4","formRow":"CemBRopT9x0qbvmhmVN44","sectionHeader":"jB2RotgQVvgSVY7z6QEJe","bottomActionCall":"_3VHXcjfMXP6jPu4XWMfIvr"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Form/Layout/Layout.css
// module id = 960
// module chunks = 0